import styled, { css } from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: fit-content;
`;

type TabProps = {
  isActive: boolean;
  isInvalid: boolean;
  isDeactivated: boolean;
};

export const Tab = styled.div<TabProps>`
  cursor: pointer;
  padding: 1rem 1rem 0.8rem;
  text-align: center;

  &:first-of-type {
    padding-left: 0rem;
    padding-right: 0rem;
  }

  &:last-of-type {
    margin-right: 0;
  }

  span {
    font-family: DM Sans, sans-serif;
    font-weight: 400;
    max-width: 100%;
    white-space: nowrap;
    transition: all 0.2s ease-in-out;
  }

  transition: border-color 0.4s;

  ${({ isActive }) =>
    isActive &&
    css`
      span {
        color: var(--primary);
        font-weight: 500;
      }
      border-bottom: 2px solid var(--primary);
    `}

  ${({ isInvalid }) =>
    isInvalid &&
    css`
      border-bottom: 2px solid var(--red) !important;

      span {
        color: var(--red) !important;
        color: #fe6565 !important;
        font-weight: 600;
      }
    `}

  ${({ isDeactivated }) =>
    isDeactivated &&
    css`
      visibility: hidden;
    `}

    &:hover {
    span {
      text-decoration: underline;
    }
  }
`;
